export enum QuietRecordStatus {
    NotApplicable = '0',
    Pending = '1',
    Approved = '2',
    Denied = '3',
}